export default {
  'userProfile.tab.basic': '基本信息',
  'userProfile.tab.salary': '薪酬方案',
  'userProfile.tab.wallet': '工资历史',
  'userProfile.tab.authority': '权限管理',
  'userProfile.tab.updateAvatar': '上传头像',
  'userProfile.tab.teachingInfo': '教学信息',
};
